<div  appPageTracking class="d-flex flex-column flex-root app-root">
    <router-outlet></router-outlet>
</div>
